/**
 * Фото перед отправкой: уменьшаем до 1568 px по длинной стороне (больше модели не нужно) и сжимаем в JPEG,
 * пока файл не станет меньше `maxBytes`. Исходный файл никуда не уходит и не сохраняется.
 */
export async function shrinkImage(file: Blob, maxSide = 1568, maxBytes = 1_500_000): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  try {
    const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
    let width = Math.max(1, Math.round(bitmap.width * scale));
    let height = Math.max(1, Math.round(bitmap.height * scale));
    for (let attempt = 0; attempt < 4; attempt++) {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (!ctx) throw new Error("canvas");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(bitmap, 0, 0, width, height);
      for (const quality of [0.85, 0.7, 0.55]) {
        const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
        if (blob && blob.size <= maxBytes) return blob;
      }
      width = Math.round(width * 0.75);
      height = Math.round(height * 0.75);
    }
    throw new Error("too_large");
  } finally {
    bitmap.close();
  }
}
